













































import {Vue, Component, Prop, Watch} from 'vue-property-decorator'
import axios from 'axios';
import ICloudUpload from '@/components/icons/ICloudUpload.vue'
import {baseUrl} from "@/service/ApiClient";

@Component({
  components: {
    ICloudUpload,
  }
})
export default class FileUpload extends Vue {
  @Prop({type: Array, default: () => ['csv'],}) formats !: any
  @Prop({type: String, default: '',}) text !: any
  @Prop({type: String, default: '',}) importItems !: any
  @Prop({type: String, default: '',}) upload_text !: any
  @Prop({type: String, default: '',}) reload_text !: any
  @Prop({type: Boolean, default: false,}) open !: any

  @Watch('open')
  getOpen(value: boolean) {
    if(value){
      this.file.progress = false
      this.file.loaded = false
      this.file.link = ''
      this.file.change = false
      this.isError = false
      this.isErrorFile = false
    }
    this.$emit('closeOpen')

  }

  file = {
    progress: false,
    value: 30,
    loaded: false,
    link: '',
    change: false,
  }
  accept: any = ''
  isError: boolean = false
  isErrorFile: boolean = false
  baseURL:any =baseUrl()

  mounted() {
    this.accept = this.formats.map((format: any) => '.' + format).join(',')
  }

  changeFile() {
    this.file.change = true;
  }

  clickInput() {
    if (!this.file.loaded || this.file.change) {
      (document.querySelector('#inputIns') as HTMLElement).click()
      this.file.change = false
    }
  }

  async saveFile(element: any) {

    this.isErrorFile = false
    this.isError = false

    if (element.files[0]) {
      let value = element.files[0].name
      let dot = value.lastIndexOf('.') + 1
      let type = value.substr(dot, value.length).toLowerCase();
      // console.log(type,this.formats,this.formats.includes(type))
      if (this.formats.includes(type)) {
        this.file.progress = true
        let result
        if(this.importItems !== 'products'){

           result = await this.uploadFile(element.files[0])
        } else {
           result = await this.uploadFileProducts(element.files[0])
        }

        if (result) {
          this.$emit('loadFile', result)
          this.file.loaded = true
          this.file.progress = true;
          this.isError = false;
          let el = (this.$refs.inputFile as HTMLElement) as any
          el.value = ''

        } else {
          this.file.loaded = false
          this.isError = true
          this.file.progress = false
          this.$emit('loadFile', false)
        }

      } else {
        this.isError = true
      }
    }
  }
  async uploadFile(file: any) {

    this.file.loaded = false;
    this.file.value = 10;
    let bodyFormData = new FormData()
    bodyFormData.append('file', file);

    try {
      const {data} = await axios({
        method: "post",
        url: this.baseURL + "v5/company/invites/file/csv/parse",
        data: bodyFormData,
        headers: {
          "Content-Type": "multipart/form-data"
        },
        onUploadProgress: (progressEvent) => {
          if (progressEvent.lengthComputable) {
            this.file.value = progressEvent.loaded;
          }
        }
      })
      return data
    } catch (e) {
      return false
    }
  }

  async uploadFileProducts(file: any) {
    this.file.loaded = false;
    this.file.value = 10;
    let bodyFormData = new FormData()
    bodyFormData.append('file', file);

    try {
      const {data} = await axios({
        method: "post",
        url: this.baseURL + "v5/company/"+this.$route.params.code+"/product/import/file",
        data: bodyFormData,
        headers: {
          "Content-Type": "multipart/form-data"
        },
        onUploadProgress: (progressEvent) => {
          if (progressEvent.lengthComputable) {
            this.file.value = progressEvent.loaded;
          }
        }
      })
      return data
    } catch (e) {
      return false
    }
  }



}
